import React, { useState } from 'react';
import PilotRequest from '../Forms/PilotRequest';
import checkWhite from '../../assets/icons/check-white.svg';
import '../../styles/bgs.css';
const pilotPoints = [
    {
        title: 'Проведение пилотного проекта при поддержке вендора',
    },
    {
        title: 'Сроки проведения пилотного проекта – от 5 дней',
    }
]

const PilotPoint = ({ title }) => {
    return (
        <div className="flex justify-start items-center xl:justify-start  xl:gap-5 text-left xl:text-left w-full max-w-[360px] xl:max-w-[600px]">
            
            <div className="bg-[#ffb805] rounded-full flex justify-center items-center w-[20px] h-[20px]">
                <img src={checkWhite} className='w-[12px] h-[12px]' alt="check-white" />
            </div>
            <div className="text-white text-base font-semibold font-['Open Sans'] max-w-[280px] xl:max-w-[600px] pl-[12px]" >
                {title}
            </div>
        </div>
    )
}
export default function Pilot() {
    const [showPilotForm, setShowPilotForm] = useState(false);
    return (
            <>
            {showPilotForm && <PilotRequest title="пилот" onClose={() => setShowPilotForm(false)} />}
            {/* Content */}
                <div className="flex flex-col xl:flex-row justify-around items-center xl:px-20 xl:py-[0px] h-[356px] xl:h-[256px] w-full px-[8px] ">
                    
                    {/* Left side */}
                    <div className="flex flex-col w-full mt-[40px] xl:mt-[0px] justify-center max-w-[360px]">

                        <h2 className="leading-normal text-[18px] xl:text-[32px] xl:leading-[44.8px] text-white font-bold font-['Open Sans'] max-w-[301px] xl:w-[301px] text-left xl:text-left pl-[5px] xl:pl-[0px]">
                            Пилотный проект
                        </h2>
                        <button onClick={() => {
                                    setShowPilotForm(true)
                                }} className="px-[10px] xl:w-[242px] py-2.5 bg-white/20 rounded-[20px] border border-white text-white text-center text-xl font-bold font-['Open Sans'] hidden xl:block mt-[20px]">
                            Заявка на пилот
                        </button>
                    </div>

                    {/* Right side */}
                    <div className="flex flex-col gap-5 w-full mt-[0px] xl:mt-0 xl:w-[551px] justify-center items-center xl:items-center xl:justify-center">
                        {pilotPoints.map((point, index) => (
                            <PilotPoint key={index} title={point.title} />
                        ))}
                    </div>

                    <div className="flex flex-col xl:hidden mb-[40px] justify-start items-start w-full xs:w-[360px]">
                        <button onClick={() => {
                                    setShowPilotForm(true)
                                }} className="px-[10px] w-full max-w-[320px] py-2.5 bg-white/20 rounded-[20px] border border-white text-white text-center text-xl font-bold font-['Open Sans']">
                        Заявка на пилот
                        </button>
                    </div>
                </div>
        </>
    );
}